<template>
    <div>
        <div class="tabulation-title" style="margin-bottom: 20px">
            <h5>
                <v-icon>label_outline</v-icon> Descriptifs
            </h5>
        </div>

        <div class="mr-auto ml-auto">
            <div v-for="content in provider.contents">
                <v-textarea
                    class="textarea"
                    v-if="content.description !== undefined && content.description !== null"
                    v-model="content.description"
                    outlined>
                    <template v-slot:label>
                        Description longue <img :src="'/images/flags/fr.png'" height="20px">
                    </template>
                </v-textarea>

                <v-textarea
                    class="textarea"
                    v-if="content.description_long !== undefined && content.description_long !== null"
                    v-model="content.description_long"
                    outlined>
                    <template v-slot:label>
                        Description longue <img :src="'/images/flags/fr.png'" height="20px">
                    </template>
                </v-textarea>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "Content",
    props: ["provider"]
}
</script>